import React, { type FunctionComponent, type ReactNode } from 'react'
import { DashFrame } from 'legacy/dash-blocks/dash-frame/DashFrame'
import { DashErrorBox } from 'legacy/dash-blocks/dash-error-box/DashErrorBox'
import { DashLoadingDots } from 'legacy/dash-blocks/dash-loading-dots/DashLoadingDots'
import { type UseGeneratedReportsAddBehaviour } from 'legacy/sections/generated-reports/components/add/utils/generatedReportsAdd.hooks'
import { useDashIntl } from 'intl/intl.hooks'
import { GeneratedReportsAddFormWrapper } from 'legacy/sections/generated-reports/components/add/components/form/GeneratedReportsAddFormWrapper'

interface Props extends UseGeneratedReportsAddBehaviour {
  header: ReactNode
}

export const GeneratedReportsAddContent: FunctionComponent<Props> = ({
  header,
  loading,
  error,
  datasetOptions,
  filterOptions,
}) => {
  const intl = useDashIntl()

  if (loading) {
    return <DashLoadingDots />
  }

  if (error) {
    const errorMessage = intl.formatMessage({
      id: 'generatedReports.newReport.errors.loadingError',
    })

    return <DashErrorBox errorMessage={errorMessage} />
  }

  return (
    <DashFrame
      header={header}
      contentBody={
        <GeneratedReportsAddFormWrapper
          datasetOptions={datasetOptions}
          filterOptions={filterOptions}
        />
      }
    />
  )
}
